import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { mergeRefs } from '@react-aria/utils';
import '../../../../../VisualAssets/IconV3/index.js';
import { useSelectTrigger } from './hooks/useSelectTrigger.js';
import { IconV3 as IconV3Memoized } from '../../../../../VisualAssets/IconV3/Icon.js';

var SelectTrigger = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children;
  var _useSelectTrigger = useSelectTrigger(props),
    isDisabled = _useSelectTrigger.isDisabled,
    triggerRef = _useSelectTrigger.triggerRef,
    triggerProps = _useSelectTrigger.triggerProps,
    contentProps = _useSelectTrigger.contentProps,
    iconContainerProps = _useSelectTrigger.iconContainerProps;
  var mergedRef = React.useMemo(function () {
    return mergeRefs(triggerRef, ref);
  }, [triggerRef, ref]);
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button"
  }, triggerProps, {
    ref: mergedRef,
    disabled: isDisabled
  }), /*#__PURE__*/React.createElement("span", contentProps, children), /*#__PURE__*/React.createElement("div", iconContainerProps, /*#__PURE__*/React.createElement(IconV3Memoized, {
    iconId: "fill.arrow.thick-dropdown",
    staticSize: "24",
    color: isDisabled ? 'state.disabled' : 'base.subtle'
  })));
}));

export { SelectTrigger };
//# sourceMappingURL=SelectTrigger.js.map
